import React from "react";
import styles from "./tab-buttons.module.scss";

const cssClassName = "tab-buttons";

interface TabButtonsProps {
  tabValue: string;
  callback: (tab: string) => void;
  tabs: string[];
}

export const TabButtons = ({ tabValue, callback, tabs }: TabButtonsProps) => {
  return (
    <div className={styles[cssClassName]}>
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => callback(tab)}
          className={`${styles[`${cssClassName}__tab-button`]} ${
            tabValue === tab
              ? styles[`${cssClassName}__tab-button--active`]
              : ""
          }`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};
